import styled from 'styled-components';

const Titulo = (props) => {
    return (
        <>
            <ContenedorTexto subindice={props.subindice} convocatoria={props.convocatoria} tituloTabla={props.tituloTabla}>
                <Texto subindice={props.subindice} tituloTabla={props.tituloTabla} >{props.texto} </Texto>
            </ContenedorTexto>
        </>
    );
}

const ContenedorTexto = styled.div`
    margin-top: ${(props) => props.subindice  ? '4%' : '1%'};
    margin-left: ${(props) => props.tituloTabla  ? '0px' : '5px'};
    width: ${(props) => props.tituloTabla  ? '98%' : '450px'};
    background:  ${(props) => props.convocatoria ? 'rgb(238, 128, 93)' : 'rgba(0, 60, 102, 0.8)'};
    color: white;
    border-radius: ${(props) => props.tituloTabla  ? '10px 10px 0 0' : '5px'};
    padding: ${(props) => props.tituloTabla  ? '10px 15px' : ''};
    font-weight:${(props) => props.tituloTabla  ? 'bold' : ''} ;
    height: ${(props) => props.tituloTabla  ? '40px' : ''};
    display: ${(props) => props.tituloTabla  ? 'flex' : ''};
`;

const Texto = styled.p`
    text-align: center;
    font-family: 'Roboto', sans-serif;
    font-size: ${(props) => props.subindice ? '25px' : props.tituloTabla ? '17px' : '30px'};
    text-decoration: none;
    font-weight: 520;
    margin-top: ${(props) => props.tituloTabla  ? '' : '2%'};
`;

export default Titulo;
